export const options = {
  hasGroups: 'The option has assigned groups',
  hasRules: 'The option has assigned rules',
  hasModels: 'The option has assigned 3D models',
  hasPackages: 'The option has assigned packages',
  assignmentsToOption: 'Assignments for the option',
  optionPropertiesInfo: 'Form property editing',
  colorInfo: 'Color of the option in the form',
  selectedInfo: 'Is the option default?',
  disabledInfo: 'Is the option disabled?',
  visibleInfo: 'Is the option visible?',
  highlightedInfo: 'Is the option highlighted?',
  numericMin: 'Minimum value',
  numericMax: 'Maximum value',
  numericValue: 'Default value',
  unit: 'Unit',
  step: 'Step',
  savedChanges: 'Saved changes',
  integrationNotIntegrated: 'The option has no assigned integration value.',
  integrationUnknownValue:
    'Unknown integration value - it may have changed in Impuls.',
  integrationStepNotIntegrated:
    "This option's step has no integration code - the option's integration value cannot be verified.",
} as const
